/** Web utilities */
export function downloadToFile(content, filename, mediaType) {
    // https://robkendal.co.uk/blog/2020-04-17-saving-text-to-client-side-file-using-vanilla-js
    // content type: 'text/csv', 'txt/plain', 'application/pdf', 'application/zip'
    const a = document.createElement("a");
    const file = new Blob([content], { type: mediaType });
    a.href = URL.createObjectURL(file);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
}
